/**
 * @turf/dissolve validates its input with `collectionOf(fc, "Polygon")`, so a
 * MultiPolygon or GeometryCollection anywhere in the collection throws
 * "Invalid input to dissolve: must be a Polygon, given MultiPolygon" before any
 * union is attempted. The boundary feed carries MultiPolygons for every area made
 * of disjoint parts, so this happens on real data.
 *
 * The union itself is a plain polygon-clipping union of every ring, so expanding
 * multi-part geometry into its constituent Polygons produces the same result while
 * satisfying the validator. Non-polygonal geometry (points, lines) cannot
 * contribute area and is dropped.
 *
 * monitor-api has its own copy of this in
 * services/monitor-api/src/repository/geodata-repo.ts. The two services share no
 * geo package to put it in. MONITOR-192.
 */
export const polygonFeaturesFromGeometry = (geometry: any): any[] => {
  if (!geometry) {
    return [];
  }

  switch (geometry.type) {
    case "Polygon":
      return [{ type: "Feature", properties: {}, geometry }];
    case "MultiPolygon":
      return (geometry.coordinates ?? []).map((coordinates: any) => ({
        type: "Feature",
        properties: {},
        geometry: { type: "Polygon", coordinates },
      }));
    case "GeometryCollection":
      return (geometry.geometries ?? []).flatMap(polygonFeaturesFromGeometry);
    default:
      return [];
  }
};
